import { MailProcessingWrapper } from './styles'
import { useTranslation } from 'react-i18next'
import { BackArrowIcon, EyeIcon, HandIcon, FailIcon, DeleteIcon, Lightning } from 'components/Icons'
import { MailProcessingType } from 'globals/models/Mail'
import { format } from 'date-fns'

interface IProps {
  processingType: MailProcessingType,
  processingDate?: string,
  customerRequest?: boolean
}

const MailProcessing = (props: IProps) => {
  const { processingType, processingDate, customerRequest } = props
  const { t } = useTranslation()
  const formatedDate = processingDate && format(new Date(processingDate), 'dd/MM/yyyy')

  return (
    <MailProcessingWrapper>
      {iconFromProcessingType(processingType)}
      {customerRequest && <Lightning />}
      {t(`mails.processing.${processingType}`, { date: formatedDate })}
    </MailProcessingWrapper>
  )
}

const iconFromProcessingType = (processingType: MailProcessingType) => {
  switch (processingType) {
    case 'to_destroy':
      return <DeleteIcon />
    case 'destroyed':
      return <DeleteIcon className="green" />
    case 'to_forward_with_query':
      return <BackArrowIcon className="yellow" />
    case 'to_forward':
      return <BackArrowIcon className="yellow" />
    case 'forwarded':
      return <BackArrowIcon className="green" />
    case 'npai':
      return <FailIcon />
    case 'unpaid':
      return <FailIcon />
    case 'to_scan_with_query':
      return <EyeIcon className="yellow" />
    case 'returning_on_business_center':
      return <HandIcon className="grey" />
    case 'available_for_provisioning':
      return <HandIcon className="yellow" />
    case 'provisioned':
      return <HandIcon className="green" />
  }
}

export default MailProcessing
